var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.758 17.6804C21.1752 15.8275 22.0282 13.5206 22.0282 11.0118C22.0282 4.9395 17.0887 0 11.0118 0C4.9395 0 0 4.9395 0 11.0118C0 17.0841 4.9395 22.0236 11.0118 22.0236C13.5206 22.0236 15.8275 21.1706 17.6804 19.7534L23.9224 25.9954L26 23.9178L19.758 17.6804ZM11.0118 19.0884C6.55848 19.0884 2.93526 15.4652 2.93526 11.0118C2.93526 6.55848 6.55848 2.93526 11.0118 2.93526C15.4652 2.93526 19.0884 6.55848 19.0884 11.0118C19.0884 15.4652 15.4652 19.0884 11.0118 19.0884Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.16f187ef56c211f9f04a58d9166348d0.svg";
export { ForwardRef as ReactComponent };